var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMakePhotoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.5969C18 16.0212 17.8314 16.4282 17.5314 16.7282C17.2313 17.0283 16.8243 17.1969 16.4 17.1969H3.6C3.17565 17.1969 2.76869 17.0283 2.46863 16.7282C2.16857 16.4282 2 16.0212 2 15.5969V6.79688C2 5.91688 2.72 5.19688 3.6 5.19688H6L7.6 2.79688H12.4L14 5.19688H16.4C16.8243 5.19688 17.2313 5.36545 17.5314 5.6655C17.8314 5.96556 18 6.37253 18 6.79688V15.5969Z",
    stroke: "#242121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9998 13.9977C11.7671 13.9977 13.1998 12.565 13.1998 10.7977C13.1998 9.03034 11.7671 7.59766 9.9998 7.59766C8.23249 7.59766 6.7998 9.03034 6.7998 10.7977C6.7998 12.565 8.23249 13.9977 9.9998 13.9977Z",
    stroke: "#242121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakePhotoIcon);
export default __webpack_public_path__ + "static/media/make-photo-icon.b6ee45da924985a762f76de6b457ba86.svg";
export { ForwardRef as ReactComponent };